













































import Vue from 'vue'
import { format, subMonths, getDate, startOfMonth, isAfter } from 'date-fns'
import { DatePickerIntervalElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'DatePickerIntervalEl',

  data: () => ({
    dates: [] as Array<string>,
    modal: false,
    dateFormat: 'yyyy-MM-dd'
  }),

  mounted () {
    this.dates = this.selectCurrentMonth()
  },

  watch: {
    dates () {
      const [start, end] = this.dates
      if (isAfter(new Date(start), new Date(end))) {
        this.dates = [end, start]
      }
    }
  },

  computed: {
    dateRangeText (): string {
      return this.dates.join(' ~ ')
    }
  },

  methods: {
    selectCurrentMonth (): Array<string> {
      const maxDate = this.maxDate()
      const start = startOfMonth(new Date(maxDate))
      return [format(start, this.dateFormat), maxDate]
    },
    maxDate (): string {
      const [year, month] = this.templateItemData.allowedMonthEnd.split('-').map(e => parseInt(e))
      const currDate = getDate(new Date(Date.now()))
      const maxAllowedMonth = new Date(year, month, currDate)
      const date = subMonths(maxAllowedMonth, 1)
      return format(date, this.dateFormat)
    }
  },

  props: {
    templateItemData: {
      type: Object as () => DatePickerIntervalElInterface,
      required: true
    }
  }
})
